import { CUSTOMER_SERVICE_EMAIL, CUSTOMER_SERVICE_PHONE_NUMBER_DISPLAY } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { EnrollmentJointLayout } from '@egw/layouts'
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { type FC } from 'react'
import { PageHeader } from '../../../components'

export const NextStepDisclosuresPage: FC = () => {
  const { t } = useTranslation('features-enrollment')

  return (
    <EnrollmentJointLayout title={t('joint.next_step_disclosures.page_title')}>
      {/* Loading initial data to make sure the user has access to this screen and retreive data based on user enrollment application */}
      {/* {isLoading ? <EnrollmentPageLoading testId="next_step_disclosures-loading" /> : null} */}

      {/* In some cases initial data can be null, so we assume if it's not loading and there's no error - we show the page */}
      {/* {!isLoading && !error ? ( */}
      <div className="w-full flex-1 flex flex-col justify-start">
        <CheckCircleIcon className="h-[4rem] w-[4rem] stroke-textSuccess stroke-[.5px] mb-sm -ml-2" />
        {/* AUTO GENERATED COMPONENTS START*/}
        <PageHeader title={t('joint.next_step_disclosures.page_title')} textClassName="text-text-header-success" />
        <div className="w-full flex-1 flex flex-col justify-start">
          <p className="text-text-body typo-primary-base mb-md">
            {t('joint.next_step_disclosures.description_1_yeet_coastal')}
          </p>
          <p className="text-text-body typo-primary-base">
            {t('joint.next_step_disclosures.description_2')}&nbsp;
            <a className="text-text-action hover:underline cursor-pointer" href={`mailto:${CUSTOMER_SERVICE_EMAIL}`}>
              {CUSTOMER_SERVICE_EMAIL}
            </a>
            &nbsp;
            {t('joint.next_step_disclosures.description_3')}&nbsp;
            <a
              className="text-text-action hover:underline cursor-pointer"
              href={`tel:${CUSTOMER_SERVICE_PHONE_NUMBER_DISPLAY}`}
            >
              {CUSTOMER_SERVICE_PHONE_NUMBER_DISPLAY}
            </a>
            .
          </p>
          <div className="flex-1 md:hidden" />
        </div>
        {/* AUTO GENERATED COMPONENTS END*/}
      </div>
      {/* ) : null} */}

      {/* This error handles the case when the initial data is not loaded, for example network error */}
      {/* {error ? (
        <div className="flex-1 flex flex-col justify-start md:justify-center">
          <GenericError errorMessage={t('common.generic_error')} />
        </div>
      ) : null} */}
    </EnrollmentJointLayout>
  )
}
